import React, { ReactElement } from 'react';
import { Routes, Route } from 'react-router-dom';

import DayGround from '~/components/backgrounds/DayGround';
import Brand from '~/components/titles/Brand';
import { FONT_SIZES } from '~/constants/typography';
import COLORS from '~/constants/colors';
import { useTitle } from '~/utils';

import PATHS, { AURI_PATH } from './constants/paths';
import NavSwitchBoard from './components/NavSwitchBoard';
import NotFound from './pages/NotFound';
import Encode from './pages/Encode';
import Decode from './pages/Decode';
import About from './pages/About';

function Auri(): ReactElement {
  useTitle('Auri');

  // Styling
  const auriStyle = {
    width: '100%',
    fontSize: FONT_SIZES.text,
    textAlign: 'center' as const,
  };
  const backgroundStyle = {
    position: 'absolute' as const,
    minHeight: '45em',
    backgroundColor: COLORS.cornflower,
    zIndex: -2,
  };
  const containerStyle = {
    display: 'flex',
    minWidth: 350,
    paddingBottom: '10em',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column' as const,
  };
  const nameStyle = {
    color: COLORS.kournikova,
  };

  return (
    <div style={auriStyle}>
      <DayGround style={backgroundStyle}>
        <div style={containerStyle}>
          <Brand
            name="author"
            topic="Rights"
            link={AURI_PATH || PATHS.home}
            nameStyle={nameStyle}
          />
          <NavSwitchBoard />
          <Routes>
            <Route path="*" element={<NotFound />} />
            <Route index element={<Encode />} />
            <Route path={PATHS.encode} element={<Encode />} />
            <Route path={PATHS.decode} element={<Decode />} />
            <Route path={PATHS.about} element={<About />} />
          </Routes>
        </div>
      </DayGround>
    </div>
  );
}

export default () => <Auri />;
